module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch2
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品编号",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch2
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店铺id",
      "size": "small"
    },
    model: {
      value: (_vm.vipparams.vip_distributor_number),
      callback: function($$v) {
        _vm.$set(_vm.vipparams, "vip_distributor_number", $$v)
      },
      expression: "vipparams.vip_distributor_number"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch2
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部商品",
      "name": "first"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ItemsList,
      "height": _vm.wheight - 330
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleBatchStore(scope.row)
            }
          }
        }, [_vm._v("添加到vip优惠商品列表中")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "缩略图",
      "width": "",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": _vm.wximageurl + scope.row.pics[0]
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": _vm.wximageurl + scope.row.pics[0]
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goods_id",
      "label": "商品ID",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              默认ID:" + _vm._s(scope.row.goods_id)), _c('br'), _vm._v("\n              当前ID:" + _vm._s(scope.row.item_id) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_bn) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.nospec) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("多规格")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("单规格")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_name) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "原价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              ￥" + _vm._s(scope.row.market_price / 100) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "商品价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              ￥" + _vm._s(scope.row.price) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50, 100, 200],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "vip优惠商品",
      "name": "second"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.vipItemList,
      "height": _vm.wheight - 330
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "goods_id",
      "label": "商品ID",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_id) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip_price",
      "label": "vip价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.editVipprice(scope.row)
            }
          },
          model: {
            value: (scope.row.vip_price),
            callback: function($$v) {
              _vm.$set(scope.row, "vip_price", $$v)
            },
            expression: "scope.row.vip_price"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "店铺id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.vipparams.page,
      "page-sizes": [10, 20, 50, 100, 200],
      "total": _vm.viptotal_count,
      "page-size": _vm.vipparams.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChangeVip,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.vipparams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.vipparams, "page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_batchStore,
      "title": "商品批量添加到vip优惠",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_batchStore = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "编辑提示",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            目前只针对怡康自营店设置VIP 价格"), _c('br'), _vm._v("\n            如果输入店铺id(英克id)则店铺类型和区域类型无效。"), _c('br'), _vm._v("\n            店铺类型和店铺区域不能同时选择"), _c('br'), _vm._v("\n            店铺区域属于怡康自营门店和第三方门店无关 目前区域数据河北数据正常，其他区域数据无维护可能不准确"), _c('br'), _vm._v("\n            建议使用店铺英克id来进行批量操作\n          ")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品id："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.current) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品bn："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentbn) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品价格："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              ¥" + _vm._s(_vm.current_goods_price) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vip优惠价格："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "min": 0,
      "maxlength": 30,
      "placeholder": "Vip优惠价格"
    },
    model: {
      value: (_vm.vipnowprice),
      callback: function($$v) {
        _vm.vipnowprice = $$v
      },
      expression: "vipnowprice"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-edit",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺类型： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择店铺类型"
    },
    model: {
      value: (_vm.default_shop_type_value),
      callback: function($$v) {
        _vm.default_shop_type_value = $$v
      },
      expression: "default_shop_type_value"
    }
  }, _vm._l((_vm.shop_type_list_default), function(shop) {
    return _c('el-option', {
      key: shop.value,
      attrs: {
        "label": shop.label,
        "value": shop.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域分类"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺id(多个店铺用英文逗号隔开)： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写店铺id"
    },
    model: {
      value: (_vm.districtId),
      callback: function($$v) {
        _vm.districtId = $$v
      },
      expression: "districtId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 50%"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveSynscVipPrice
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量修改库存",
      "visible": _vm.storeUpdate,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.storeUpdate = $event
      }
    }
  }, [_vm._v("\n      统一库存："), _c('el-input', {
    attrs: {
      "size": "mini",
      "type": "number"
    },
    model: {
      value: (_vm.itemstore),
      callback: function($$v) {
        _vm.itemstore = $$v
      },
      expression: "itemstore"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.storeUpdate = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveItemsStore
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26313f64", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26313f64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/vipitemlist.vue
// module id = 2550
// module chunks = 0